<template>
    <div class="container mt-4 mb-4">
        <div class="row">
            <div class="col-12 border shadow-sm rounded">
                <div id='invoice-pending-overview-title' class="row border-bottom title-square-background rounded-top">
                  <div class="col-12 d-flex justify-content-between mb-1 mt-1">
                    <div class="title-square">
                      <div class="mt-2 mb-2">
                        <strong>INVOICE</strong>
                      </div>
                    </div>
                  </div>  
                </div>
                <div id='invoice-pending-overview-detail'>
                  <div class="mt-2 mb-2">
                    <!-- Indicator -->
                    <div class="row">
                      <div class="col-3">
                        <span class="invoice-overview-indicator">Total Invoice</span>
                      </div>
                      <div class="col-3">
                        <span class="invoice-overview-indicator">Total Outstanding Invoice</span>
                      </div>
                      <div class="col-3">
                        <span class="invoice-overview-indicator">Total Amount</span>
                      </div>
                      <div class="col-3">
                        <span class="invoice-overview-indicator">Total Due</span>
                      </div>
                    </div>
                    <!-- Value -->
                    <div class="row">
                      <div class="col-3">
                        <span class="invoice-overview-value">{{invoiceOveriewCount.totalInvoice}}</span>
                      </div>
                      <div class="col-3">
                        <span class="invoice-overview-value">{{invoiceOveriewCount.totalOutstandingInvoice}}</span>
                      </div>
                      <div class="col-3">
                        <span class="invoice-overview-value">Rp {{formatPrice(invoiceOveriewCount.totalAmount)}}</span>
                      </div>
                      <div class="col-3">
                        <span class="invoice-overview-value">Rp {{formatPrice(invoiceOveriewCount.totalAmountDue)}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="mt-4 mb-4">
                    <div class="row">
                      <div class="col-8">
                        <div class="mb-2">
                          <span class="most-overdue-title">Most Overdue</span>
                        </div>
                        <div v-for="data in mostOverdue" :key="data.id">
                          <div class="row mb-2">
                            <div class="col-3 most-overdue-orange">
                              {{data.daysOverdue}} days overdue
                            </div>
                            <div class="col-4 most-overdue-text">
                              <div style="width:160px;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                                {{data.companyName}}
                              </div>
                            </div>
                            <div class="col-2 most-overdue-text">
                              {{data.totalOrder}} Orders
                            </div>
                            <div class="col-2 most-overdue-text">
                              {{data.totalUnit}} Unit  
                              <svg style="cursor:pointer" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" @click="searchInvoiceInfo(data.companyId, data.companyName)">
                                <path d="M3 9.5C2.60218 9.5 2.22064 9.34196 1.93934 9.06066C1.65804 8.77936 1.5 8.39782 1.5 8C1.5 7.60218 1.65804 7.22064 1.93934 6.93934C2.22064 6.65804 2.60218 6.5 3 6.5C3.39782 6.5 3.77936 6.65804 4.06066 6.93934C4.34196 7.22064 4.5 7.60218 4.5 8C4.5 8.39782 4.34196 8.77936 4.06066 9.06066C3.77936 9.34196 3.39782 9.5 3 9.5ZM8 9.5C7.60218 9.5 7.22064 9.34196 6.93934 9.06066C6.65804 8.77936 6.5 8.39782 6.5 8C6.5 7.60218 6.65804 7.22064 6.93934 6.93934C7.22064 6.65804 7.60218 6.5 8 6.5C8.39782 6.5 8.77936 6.65804 9.06066 6.93934C9.34196 7.22064 9.5 7.60218 9.5 8C9.5 8.39782 9.34196 8.77936 9.06066 9.06066C8.77936 9.34196 8.39782 9.5 8 9.5ZM13 9.5C12.6022 9.5 12.2206 9.34196 11.9393 9.06066C11.658 8.77936 11.5 8.39782 11.5 8C11.5 7.60218 11.658 7.22064 11.9393 6.93934C12.2206 6.65804 12.6022 6.5 13 6.5C13.3978 6.5 13.7794 6.65804 14.0607 6.93934C14.342 7.22064 14.5 7.60218 14.5 8C14.5 8.39782 14.342 8.77936 14.0607 9.06066C13.7794 9.34196 13.3978 9.5 13 9.5Z" fill="black"/>
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'InvoiceListOverviewCard',
  data () {
    return {
      admin:"",
      permission:[],
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      monthName : ['January','February','March','April','May','June','July','August','September','October','November','December'],
      invoiceOveriewCount : {
        totalAmount : 0,
        totalAmountDue : 0,
        totalInvoice : 0,
        totalOutstandingInvoice: 0,
      },
      mostOverdue :[],
    }
  },
  methods:{
    formatPrice(value) {
      let val = value  ? value : 0;
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    searchInvoiceInfo(id, name) {
      this.$router.push({path:'/invoicing/list', query: {
          page : 1,
          itemPerPage : 10,
          companyId: id,
          companyName: name,
          invoiceStatusName : '',
          invoiceStatus : '',
          invoiceNumber: '',
          jurnalStatus : '',
          jurnalStatusName : '',
          orderId : '',
        }
      })
    },
    getInvoiceOverview() {
      this.$http.get(`${process.env.GET_INVOICE_OVERVIEW}/invoiceList`,
      {
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if(!response.data.status == 200) {
          this.pendingInvoiceData = []
          swal("Error", response.data.message , "error")
        } else {
          this.invoiceOveriewCount = response.data.data.dataCount
          this.mostOverdue = response.data.data.mostOverdue
        }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
  },
  created(){
    this.getInvoiceOverview()
    // this.admin = localStorage.getItem('admin_name')
    // this.cekLogin()
    // this.cekPermission()
  }
}
$(document).ready(function(){
  var self = this
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .title-square-background {
    background-color: #F8F9FB;
  }

  .invoice-overview-indicator{
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .invoice-overview-value {
    color: #000;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 110% */
    letter-spacing: -0.02px;
  }

  .most-overdue-title {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .most-overdue-text {
    color: #2E3646;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .most-overdue-orange {
    color: #FF5252;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px){
  .mobile-div{
    padding: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Invoicing/CustomComponent/InvoiceListOverviewCard.vue